/**
 * 주문 셀 라인 축약 유틸 — 초기화 팝업(WowposResetPopup) / 관리자 주문내역 개요 공용.
 * 메뉴명 기준 수량 합산(옵션 무시), 최초 등장 순서 유지, MAX_LINES 초과 시 앞부분 + '…'.
 */
export const MAX_LINES = 6;

/**
 * @param {{ menuItems?: Array<{name?: string, quantity?: number, qty?: number}> }} orderData
 * @returns {Array<{name: string, qty: string}>}
 */
export function buildLines(orderData, maxLines = MAX_LINES) {
  const map = new Map();
  const order = [];
  for (const m of (orderData?.menuItems || [])) {
    const name = (m.name || '').trim();
    if (!name) continue;
    const qty = Number(m.quantity ?? m.qty) || 1;
    if (map.has(name)) map.set(name, map.get(name) + qty);
    else { map.set(name, qty); order.push(name); }
  }
  let lines = order.map((n) => ({ name: n, qty: String(map.get(n)) }));
  if (lines.length > maxLines) {
    lines = lines.slice(0, maxLines - 1).concat([{ name: '…', qty: '' }]);
  }
  return lines;
}
